import { request } from "../../apis";

export const apiGetPreferProject = (params) => request("get", `/facility/homeindex`, params, false);

export const apiGetHomePopup = (params) => request("get", `/index/home_popup`, params, false);

export const apiGetPayCaseUrl = (params) => request("get", `/index/pay_case_url`, params, true);
